module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "figx"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg17.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "chtitle3"
  }, [_vm._v("BEADS AND EMBELLISHMENTS: CANDY WITH NO CALORIES!")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg17-1.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption"
  }, [_vm._v("Detail of Blowing Bubbles: Jewel Bubbles project (See full photo and project instructions.)")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg17-2.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption"
  }, [_vm._v("Detail of "), _c('i', [_vm._v("Sizzle and Pop")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg17-3.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption"
  }, [_vm._v("Glass Flowers, project inspiration for Beaded Bracelets")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Beads, buttons, charms, sequins, and other embellishments come in a variety of shapes, sizes, colors, and finishes. Once you begin to collect these items, your imagination will ignite, and the ideas will start to flow. I suggest that you make time for a “play day” at least once a week so that you can explore the possibilities!")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('span', {
    staticClass: "ros"
  }, [_vm._v("TINY, SHINY TREASURES!")])]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Initially the word "), _c('i', [_vm._v("bead")]), _vm._v(" brings to mind sparkling little round wonders of light and color, but beads come in many different shapes and sizes. Seed beads are numbered from low to high: the higher the number, the smaller the bead. Bugle beads are numbered in millimeters.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('b', [_c('i', [_vm._v("Shapes and Sizes")])])]), _vm._v(" "), _c('div', {
    staticClass: "rose"
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg18.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption"
  }, [_vm._v("Size 6°, 8°, 11°, and 15° seed beads")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_c('b', [_vm._v("Round seed beads")]), _vm._v(", or "), _c('i', [_vm._v("rocailles")]), _vm._v(", are round and even in shape and come in sizes 5° to 18°; some vintage beads can be found as small as size 24°. These beads, referred to as "), _c('i', [_vm._v("SBs")]), _vm._v(" in embroidery tables in this book, can be worked effectively into any of the bead embroidery and bead woven stitches.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg18-1.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption"
  }, [_vm._v("Size 10° and 11° delica beads")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_c('b', [_vm._v("Cylinder beads")]), _vm._v(", called "), _c('i', [_vm._v("delica")]), _vm._v(" or "), _c('i', [_vm._v("antiques")]), _vm._v(", are tube shaped and come in sizes 8° to 11°. The shape and consistent size make them perfect for the peyote and brick stitch designs, but they can also be used for the bead embroidery stitches.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg18-2.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption"
  }, [_vm._v("Size 8° and 12° cut beads")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_c('b', [_vm._v("Cut beads")]), _vm._v(" are round in shape, with one or several sides squared off to create sparkle. They come in sizes 8° to 15°. These beads can be worked effectively into any of the bead embroidery and bead woven stitches.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg18-3.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption"
  }, [_vm._v("Size 8° and 15° hex cut beads")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_c('b', [_vm._v("Hex cut beads")]), _vm._v(" are six sided and come in sizes 5° to 15°. These beads can be worked effectively into any of the bead embroidery and bead woven stitches.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg18-4.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption"
  }, [_vm._v("Size 4° and 11° square beads")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_c('b', [_vm._v("Square beads")]), _vm._v(" have four sides and come in sizes 4° to 15°. The shape and consistent size make them perfect for the peyote and brick stitch designs, but they can also be used for the bead embroidery stitches.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg18-5.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption"
  }, [_vm._v("Size 6° and 10° triangular beads")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_c('b', [_vm._v("Triangular beads")]), _vm._v(" have three sides and come in sizes 6° to 15°. These beads can be used for the bead embroidery and bead woven stitches.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg18-6.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption"
  }, [_vm._v("Size 12 mm, 8 mm, 6 mm, and 4 mm bugle beads")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_c('b', [_vm._v("Bugle beads")]), _vm._v(" are long and cylindrical in shape, often with faceted sides, and come in sizes 2 mm to 20 mm. These beads can be worked into several of the bead embroidery stitches.")])]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('b', [_c('i', [_vm._v("Not All Beads Are Created Equal …")])])]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ros1"
  }, [_vm._v("1.")]), _vm._v(" 6° seed bead")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ros1"
  }, [_vm._v("2.")]), _vm._v(" 8° seed bead")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ros1"
  }, [_vm._v("3.")]), _vm._v(" 11° seed bead")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ros1"
  }, [_vm._v("4.")]), _vm._v(" 8° seed bead")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ros1"
  }, [_vm._v("5.")]), _vm._v(" 7 mm bugle bead")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ros1"
  }, [_vm._v("6.")]), _vm._v(" 11° seed bead")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ros1"
  }, [_vm._v("7.")]), _vm._v(" 11° seed bead")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ros1"
  }, [_vm._v("8.")]), _vm._v(" 8° seed bead")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ros1"
  }, [_vm._v("9.")]), _vm._v(" 11° seed bead")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ros1"
  }, [_vm._v("10.")]), _vm._v(" 15° seed bead")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ros1"
  }, [_vm._v("11.")]), _vm._v(" 6° seed bead")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ros1"
  }, [_vm._v("12.")]), _vm._v(" 11° seed bead")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ros1"
  }, [_vm._v("13.")]), _vm._v(" 4° square bead")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ros1"
  }, [_vm._v("14.")]), _vm._v(" 8° seed bead")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ros1"
  }, [_vm._v("15.")]), _vm._v(" 11° seed bead")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg19-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Most of the glass beads that you find today (sold loose in packages or in tubes by weight) are made in Japan and are, for the most part, even in size and shape. The consistency in size and shape make them an excellent choice for both bead woven and bead embroidery stitches. See 7 in the bead sampler (at right).")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Beads made in the Czech Republic (usually sold in hanks of 10–14 strands, in 14˝–20˝ lengths per strand) may differ slightly in size. The slight imperfections in size and shape are not a problem for most bead embroidery stitches but lend a challenge to bead woven stitches. See 6 in the bead sampler (at right).")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg19.jpg"
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "Caption"
  }, [_vm._v("Examples of a bead woven flower: A. Evenly shaped beads, B. Unevenly shaped beads")]), _vm._v(" "), _c('p', {
    staticClass: "tip"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/rose.jpg"
    }
  }), _vm._v(" "), _c('b', [_c('i', [_vm._v("Tip: Bead Blips")])])]), _vm._v(" "), _c('p', {
    staticClass: "tip-txt"
  }, [_vm._v("In your group of beads, you will occasionally find a “bead blip”: a bead that is not quite formed or that doesn’t have a hole. I put these into a glass jar and just look at them to appreciate the colors.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('b', [_c('i', [_vm._v("Finishes")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Glass beads are made from sand; the colors are achieved by adding various materials. Once the bead is made, additional effects can be created by adding color to the surface of the bead or to the inside of the bead hole.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg20.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ros1"
  }, [_vm._v("1.")]), _vm._v(" Transparent: Clear color with a shiny finish")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ros1"
  }, [_vm._v("2.")]), _vm._v(" Gold or silver lined: Transparent color with gold or silver painted inside the bead hole")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ros1"
  }, [_vm._v("3.")]), _vm._v(" Color lined: Transparent color with a different color painted inside the bead hole")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ros1"
  }, [_vm._v("4.")]), _vm._v(" Aurora borealis (AB): Transparent color with an AB (pink, green, and gold) finish")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ros1"
  }, [_vm._v("5.")]), _vm._v(" Matte AB: Transparent color with a matte AB (pink, green, and gold) finish")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ros1"
  }, [_vm._v("6.")]), _vm._v(" Luster: Transparent color with a gold-washed finish")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ros1"
  }, [_vm._v("7.")]), _vm._v(" Opaque: Solid color with a flat nonreflective finish")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ros1"
  }, [_vm._v("8.")]), _vm._v(" Opaque lustered: Solid color with a shiny finish")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ros1"
  }, [_vm._v("9.")]), _vm._v(" Ceylon: Solid color with a shiny whitish finish")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ros1"
  }, [_vm._v("10.")]), _vm._v(" Metallic: Heavy solid metallic finish")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ros1"
  }, [_vm._v("11.")]), _vm._v(" Iris: Matte "), _c('i', [_vm._v("or")]), _vm._v(" shiny multicolored hues of purple, blue, green, or gunmetal")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "ros1"
  }, [_vm._v("12.")]), _vm._v(" Raku: Matte with multiple hues")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('span', {
    staticClass: "ros"
  }, [_vm._v("EMBELLISHMENTS GALORE: THE MORE THE MERRIER!")])]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Adding larger beads, charms, and buttons gives interest and definition to your project. The beads and charms are measured by millimeters: the lower the number, the smaller the bead. Buttons are measured in lines or fractions of an inch. The materials vary, so keep in mind the weight of these items, prepare your base, and place them accordingly.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('b', [_c('i', [_vm._v("Large Beads, Sequins, Charms, and Buttons")])])]), _vm._v(" "), _c('div', {
    staticClass: "rose"
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg21.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Caption1"
  }, [_vm._v("Glass beads")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg21-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Caption1"
  }, [_vm._v("Rondelles")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg21-2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Caption1"
  }, [_vm._v("Sequins")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg21-3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Caption1"
  }, [_vm._v("Metal charms")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg21-4.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Caption1"
  }, [_vm._v("Flower, leaf, and motif charms")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg21-5.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Caption1"
  }, [_vm._v("Buttons")])]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Larger glass beads can be round, oblong, or square. They come in sizes 2 mm to 20 mm.")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Rondelles are flat or puffed, circular or floral shaped with a single hole in the center. They come in sizes 4 mm and larger. These can be made from glass, shell, metal, or plastic.")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Sequins are round or square with a center hole and are made from Mylar or nylon. Novelty shapes have a hole in the center or as a part of the design.")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Metal charms come with a hole that is part of the design. The position of the hole determines how it will be sewn to the project. Various metal and metal alloys are used.")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Flower, leaf, and motif shaped charms come with a hole that is part of the design. The position of the hole determines how it will be sewn to the project. These can be made from glass, shell, or plastic.")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Buttons come in two styles, sew on or shank. Sew-on buttons have two to four holes through the middle of the face. Shank buttons have a solid face; the back of the button has a small section with a hole in it or a metal loop. Buttons can be made from glass, shell, wood, metal, or plastic.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('span', {
    staticClass: "ros"
  }, [_vm._v("USING COLOR EFFECTIVELY")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg22.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Caption1"
  }, [_vm._v("A. Clear and solid-color beads, B. Lined beads, C. Aurora borealis (AB) and multi-finished beads")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("The coloring of the bead can also make a difference and a great deal of impact on a design. For instance, the coloring of a clear bead remains the same whether the side of the bead is positioned flat against the fabric or turned to see the hole. A lined bead, however, changes in color. When positioned flat against the fabric, you see the combination of both colors, but when turned to see the hole, you see the lining color. Beads that are made with a variety of colors or finishes, like an aurora borealis finish, vary per bead and offer another design element.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg22-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Caption1"
  }, [_c('i', [_vm._v("Champagne and Pearls")]), _vm._v(", gallery inspiration for Feminine Fancies project")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg22-2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Caption1"
  }, [_c('i', [_vm._v("Welcome Home")]), _vm._v(", gallery inspiration for Feminine Fancies project")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Here are two examples of the same design worked with different fabrics, beads, and button shapes. The first example with the black background is quite striking. The embroidery is worked in an almost monochromatic color scheme using solid-color beads. The second example uses color in a different way: It starts with a solid and a printed fabric, and the beads and embellishments are in a variety of colors and finishes.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e8a1d0b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/08_chapter03.vue
// module id = 78
// module chunks = 0